'use client';

import React from 'react';
import { LDFeatureFlags } from '@/constants/featureFlags';

export type FeatureFlagsContextValues = {
  isEnabled: (flag: LDFeatureFlags) => boolean;
};

type FeatureFlagsProviderProps = {
  children: React.ReactNode;
  flags: Record<string, boolean>;
};

export const FeatureFlagsContext =
  React.createContext<FeatureFlagsContextValues>({
    isEnabled: () => {
      return false;
    },
  });

export const FeatureFlagsProvider: React.FC<FeatureFlagsProviderProps> = ({
  flags,
  children,
}) => {
  const isEnabled = (flag: LDFeatureFlags): boolean => {
    return flags?.[flag] ?? false;
  };

  return (
    <FeatureFlagsContext.Provider value={{ isEnabled }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};
